import React from "react";
import lax from "lax.js";

class Partner extends React.Component {
  constructor(props) {
    super(props);
    lax.setup();

    document.addEventListener(
      "scroll",
      function (x) {
        lax.update(window.scrollY);
      },
      false
    );

    lax.update(window.scrollY);
  }

  render() {
    return (
      <div className="row">
        <div className="col-lg-12">
          <div className="partner-title platinum-sponsor">
            <h3 className="lax" data-lax-preset="driftRight">
              Patrocinadores
            </h3>
          </div>
        </div>

        <div className="col-lg-4 col-md-4 col-12">
          <div className="partner-item">
            <img
              src={require("../../assets/images/logos/sm.jpg")}
              alt="sponsor"
            />
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-12">
          <div className="partner-item">
            <img
              src={require("../../assets/images/logos/sabadell.jpg")}
              alt="sponsor"
            />
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-12">
          <div className="row">
            <div className="col-12">
              <div className="partner-item">
                <img
                  src={require("../../assets/images/logos/olmata.png")}
                  alt="sponsor"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="partner-item">
                <img
                  src={require("../../assets/images/logos/genser.png")}
                  alt="sponsor"
                />
              </div>
            </div>
            <div className="col-6">
              <div className="partner-item">
                <img
                  src={require("../../assets/images/logos/mcyadra.jpg")}
                  alt="sponsor"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Partner;
